import styled from 'styled-components'

// El campo sale del tema (MuiOutlinedInput, 40 px); aquí solo el ajuste del icono del calendario
const SingleDatePickerStyled = styled.div`
  width: 100%;

  .MuiOutlinedInput-adornedEnd {
    padding-right: 4px;
  }
`

export default SingleDatePickerStyled
